import { Grid, Typography } from '@mui/material';
import type { Currency, PerUnitProductVariantInput } from '@vy/types';
import { withDefault } from '@vy/utils';
import React from 'react';
import { Price } from '../../../../../../../../components/design/Price';

type LivePreviewPerUnitItemProps = {
  productVariant: PerUnitProductVariantInput;
  currency: Currency;
};

export const LivePreviewPerUnitItem: React.FC<LivePreviewPerUnitItemProps> = ({
  productVariant,
  currency,
}) => {
  return (
    <Grid component="li" container>
      <Grid size={6}>
        <Typography
          sx={{
            color: "#111B1E",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px"
          }}>
          {withDefault(productVariant.name, '')}
        </Typography>
      </Grid>
      <Grid size={6} sx={{
        textAlign: "right"
      }}>
        <Typography
          sx={{
            color: "#9DA8AC",
            fontWeight: 300,
            fontSize: "12px",
            lineHeight: "16px"
          }}>
          Price Per Unit
        </Typography>
      </Grid>
      <Grid size={12} sx={{
        textAlign: "right"
      }}>
        <Price
          color="#111B1E"
          sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '16px' }}
          currency={currency}
          align="right"
        >
          {withDefault(productVariant.pricing.priceConfiguration?.price, 0)}
        </Price>
      </Grid>
    </Grid>
  );
};
